/* eslint-disable max-len */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
    privileges: {
        "admin_user_list": false,
        "add_admin_user": false,
        "update_admin_user": false,
        "activate_or_deactivate_admin_user": false,
        "order_list": false,
        "view_order": false,
        "store_list": false,
        "add_store": false,
        "update_store": false,
        "activate_or_deactivate_store": false,
        "onboard_merchant": false,
        "merchant_list": false,
        "view_merchant": false,
        "update_merchant": false,
        "activate_or_deactivate_merchant": false,
        "employee_list": false,
        "add_employee": false,
        "update_employee": false,
        "activate_or_deactivate_employee": false,
        "support_request_list": false,
        "view_support_request": false,
        "change_settlement_status": false,
        "settlement_list": false,
        "view_settlement": false,
        "change_support_ticket_status": false,
        "view_dashboard": false
    }
}

function processPermissions(permissionsString, previousPrivileges = {}) {
    // Handle empty or invalid input gracefully
    if (!permissionsString || typeof permissionsString !== 'string') {
        return previousPrivileges; // Return previous state if input is invalid
    }

    // Validate format (optional):
    // You can add optional checborderks to ensure the input string is in the expected format
    // using regular expressions or other validation techniques.

    // Split and convert to object:
    const processedPermissions = permissionsString.split(',')
        .map(permission => permission.trim()) // Remove leading/trailing whitespace
        .reduce((acc, permission) => ({ ...acc, [permission]: true }), {});

    // Merge processed permissions with previous state
    return { ...previousPrivileges, ...processedPermissions };
}

const authSlice = createSlice({
    name: 'Privileges',
    initialState,
    reducers: {
        addPrivileges: (state, action) => {
            let res = processPermissions(action.payload)
            state.privileges = {...res}
        },
        removePrivilages: (state, action) => {
            state.privileges = initialState
        }
    },
})
export const { addPrivileges,removePrivilages } = authSlice.actions;
export default authSlice.reducer